import React from 'react';
import PropTypes from 'prop-types';
import SMOwnerResource from 'resources/SMOwnerResource';
import SMFormSubmitButton from 'components/dashboard/form/SMFormSubmitButton';
import SMTrackHelper from 'components/helpers/SMTrackHelper';
import SMOReservationDialogHeaderView from './SMOReservationDialogHeaderView';

class SMOReservationRejectView extends React.Component {
  
  componentDidMount() {
    $(this.refs.form).find("input[type=radio]").on("change", (e)=>{
      $(".js-form-radio-select_message").hide();
      let $message = $(this.refs[e.currentTarget.id]);
      if ($message.length) {
        $message.fadeIn();
      }
    });
  }
  
  trackPageEvent(label) {
    SMTrackHelper.pageEvent(label);
  }
  
  formDidSubmit(e){
    e.preventDefault();
    let selectedCheckBox = 0;
    for (let i = 0; i < this.refs.form.children[1].length; i++){
      if (this.refs.form.children[1][i].checked) {
        selectedCheckBox = this.refs.form.children[1][i].value;
        break;
      }
    }
    this.trackPageEvent('od reject_reservation lost_reason_type_' + selectedCheckBox.toString());
    let formData = new FormData(e.currentTarget);
    $(this.refs.form).startLoading();
    SMOwnerResource.reject(this.props.reservation, formData, (data, error, xhr)=>{
      $(this.refs.form).stopLoading();
      if (!error) {
        if(this.props.delegate && typeof this.props.delegate.reservationDidReject === 'function'){
          this.props.delegate.reservationDidReject(data, xhr);
        }
      } else {
        if(this.props.delegate && typeof this.props.delegate.reservationDidFailToReject === 'function'){
          this.props.delegate.reservationDidFailToReject(error, xhr);
        }
      }
    });
  }
  
  render() {
    let reservation = this.props.reservation,
        calendarUrl = Routes.owner_dashboard_path(
          reservation.owner.username, {
            space_id: reservation.room.space.username,
            room_id: reservation.room.uid,
          }
        );
    return (
      <div ref="form" className="form-casette maincol-lightbox__form">
        <SMOReservationDialogHeaderView />
        <h2 className="dashboard-title mb30 ta-c" 
          dangerouslySetInnerHTML={{__html: I18n.t("dashboard.text_000028")}} />
        <form onSubmit={this.formDidSubmit.bind(this)}>
          <div className="form-box">
            <h3 className="dashboard-title mb20">
              <span className="icon-form icon-form__required">{I18n.t("dashboard.label_000025")}</span>
              {I18n.t("dashboard.label_000137")}
              <span className="dashboard-title__supplement ml15">{I18n.t("dashboard.text_000029")}</span>
            </h3>
            <input type="radio" value="1" id="form-radio01__01" name="lost_reason_type" />
            <label htmlFor="form-radio01__01" className="form-radio__s">利用できない日であったため</label><br />
            <div ref="form-radio01__01" className="js-form-radio-select_message dashboard-message__info mt10">
              <p>承認率の低下はホストとしての評価に影響することがあります。<a target="_blank" href={calendarUrl}>予約カレンダー</a>を適切にメンテナンスすることで否認の作業を未然に防ぐことができます。ご確認ください。</p>
            </div>
            <input type="radio" value="2" id="form-radio01__02" name="lost_reason_type" />
            <label htmlFor="form-radio01__02" className="form-radio__s">ゲストに違和感や不安を感じる</label><br />
            <input type="radio" value="3" id="form-radio01__03" name="lost_reason_type" />
            <label htmlFor="form-radio01__03" className="form-radio__s">ゲストのニーズとスペースが合わない</label><br />
            <input type="radio" value="4" id="form-radio01__04" name="lost_reason_type" />
            <label htmlFor="form-radio01__04" className="form-radio__s">より良い条件の予約を待ちたい</label><br />
            <input type="radio" value="5" id="form-radio01__05" name="lost_reason_type" />
            <label htmlFor="form-radio01__05" className="form-radio__s">ゲストが別日への変更を希望している</label><br />
            <div ref="form-radio01__05" className="js-form-radio-select_message dashboard-message__info mt10">
              <p><a target="_blank" href={Routes.edit_owner_dashboard_reservation_path(reservation.owner.username, reservation.uid)}>予約の編集</a> 画面から料金や日程を変更することができます。キャンセルをする前に対応が可能かご確認ください。</p>
            </div>
            <input type="radio" value="6" id="form-radio01__06" name="lost_reason_type" />
            <label htmlFor="form-radio01__06" className="form-radio__s">スパムメッセージのため</label><br />
            <input type="radio" value="7" id="form-radio01__07" name="lost_reason_type" />
            <label htmlFor="form-radio01__07" className="form-radio__s">その他</label>
            <div ref="form-radio01__07" className="js-form-radio-select_message dashboard-message__info mt10">
              <textarea name="lost_reason_description" className="form-textarea h40 w400" placeholder="理由を記述してください"></textarea>
            </div>
            <h3 className="dashboard-title mb20 mt20">
              <span className="icon-form icon-form__optional">{I18n.t("dashboard.label_000060")}</span>
              {I18n.t("dashboard.label_000011")}
              <span className="dashboard-title__supplement ml15">
                ゲスト希望者に否認になった理由を下記に記述し、伝えて下さい（400字以内）
              </span>
            </h3>
            <textarea name="content" className="w700 h80" placeholder="希望に添えないため、予約リクエストを否認させていただきます。また機会がありましたら、よろしくお願い致します。"></textarea>
          </div>
          <div className="ta-c mb30">
            <SMFormSubmitButton 
              title={I18n.t("dashboard.label_000110")} 
              options={{className: "button-green maincol-buttonarea__button"}} />
          </div>
        </form>
      </div>
    );
  }
}
SMOReservationRejectView.propTypes = {
  delegate: PropTypes.object,
  reservation: PropTypes.object.isRequired
};
export default SMOReservationRejectView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/owners/reservations/SMOReservationRejectView.jsx